import React from 'react'
import styled from 'styled-components'
import Link from 'gatsby-link'

import Speaker from '../components/speaker'

const Section = styled.section`
  max-width: 1000px;
  h2 {
    margin-bottom: 5rem;
  }
  div:last-of-type {
    border-bottom: 0;
    margin-bottom: 2.5rem;
  }
`

class SpeakersPage extends React.Component {
  render() {
    const { data } = this.props
    return (
      <Section>
        <h2>Speakers</h2>
        {data.allMarkdownRemark.edges.map(({ node }, i) => {
          const shortSlug = node.fields.slug.split('/')[2]
          return (
            <Speaker
              key={i}
              name={node.frontmatter.name}
              title={node.frontmatter.title}
              photo={node.frontmatter.profilePic.childImageSharp.sizes}
              photoTwo={
                node.frontmatter.profilePicTwo
                  ? node.frontmatter.profilePicTwo.childImageSharp.sizes
                  : null
              }
              bio={node.frontmatter.bio}
              twitter={node.frontmatter.twitter}
              website={node.frontmatter.website}
              talkTitle={node.frontmatter.talkTitle}
              talkHTML={node.html}
              shortSlug={shortSlug}
            />
          )
        })}
      </Section>
    )
  }
}

export default SpeakersPage

export const query = graphql`
  query SpeakersQuery {
    allMarkdownRemark {
      edges {
        node {
          fields {
            slug
          }
          excerpt
          html
          frontmatter {
            title
            name
            profilePic {
              childImageSharp {
                sizes {
                  base64
                  tracedSVG
                  aspectRatio
                  src
                  srcSet
                  srcWebp
                  srcSetWebp
                  sizes
                  originalImg
                  originalName
                }
              }
            }
            profilePicTwo {
              childImageSharp {
                sizes {
                  base64
                  tracedSVG
                  aspectRatio
                  src
                  srcSet
                  srcWebp
                  srcSetWebp
                  sizes
                  originalImg
                  originalName
                }
              }
            }
            twitter
            website
            bio
            talkTitle
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/speakers.js